const isSafari = () => {
  const client = navigator.userAgent.toLowerCase()
  return !!client.match(/safari/i) && !!client.match(/WebKit/i) && !client.match(/chrome/i)
}

export default isSafari